<template>
  <b-switch
    v-model="internalValue">
  </b-switch>
</template>

<script>
export default {
  name: 'SwitchWatch',
  props: {
    id: {
      type: String,
      required: true,
    },
    onChange: {
      type: Function,
      required: true,
    },
    value: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    item: {
      handler(val) {
        this.onChange(this.item.id, val.value === 'Yes');
      },
      deep: true,
    },
    internalValue() {
      this.onChange(this.id, this.internalValue);
    },
  },
  data() {
    return {
      internalValue: this.value,
    };
  },
};
</script>

<style lang="scss" scoped>

</style>
